import { normalizeHaklaiExpensesForDependencies } from "../calc/expenses/logic/haklaiExpensesHelpers";
import { sanitizePre1997ConstructionFlags } from "../calc/shared/haklaiRawPayloadHelpers";
import { applyHaklaiPrisaDependencies } from "./haklaiPrisaDependencies";

export const applyHaklaiPreCalcDependencyRules = (calcState, fieldName, value) => {
  const updated = {
    ...calcState,
    preCalc: { ...calcState.preCalc, [fieldName]: value }
  };

  if (fieldName === "soldPropertyDate") {
    updated.preCalc.hasTzinunOnPtor = false;
  }

  if (fieldName === "hasZaban" || fieldName === "wayOfGettingProperty") {
    const normalizedExpensesState = normalizeHaklaiExpensesForDependencies(
      updated.mainCalc?.expenses || [],
      updated.mainCalc?.propertyPartsData || {},
      updated.preCalc?.hasZaban === true
    );

    if (normalizedExpensesState.changed) {
      updated.mainCalc = {
        ...(updated.mainCalc || calcState.mainCalc),
        expenses: normalizedExpensesState.expenses
      };
    }
  }

  const sanitizedPre1997State = sanitizePre1997ConstructionFlags(
    updated.mainCalc?.propertyPartsData || {},
    updated.preCalc
  );
  if (sanitizedPre1997State.changed) {
    updated.mainCalc = {
      ...(updated.mainCalc || calcState.mainCalc),
      propertyPartsData: sanitizedPre1997State.propertyPartsData
    };
  }

  if (fieldName === "soldPropertyDate" || fieldName === "wayOfGettingProperty") {
    return applyHaklaiPrisaDependencies(updated);
  }

  return updated;
};
